<template>
  <div>
    <div style="display: flex; align-items: flex-start;">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <neta-list/>
    </div>
  </div>
</template>

<script>
import NetaList from '../../../components/reports/neta/central/List';
import Sidebar from '../../../components/reports/neta/Sidebar';

export default {
  components: {
    NetaList,
    Sidebar,
  },
  data() {
    return {

    }
  },
  computed: {
  },
  async mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    width: 150px;
  }
  .el-picker-panel [slot=sidebar]+.el-picker-panel__body, .el-picker-panel__sidebar+.el-picker-panel__body {
    margin-left: 150px;
  }
</style>
